export default __webpack_public_path__ + "resources/icons/n210-7872.png";